module.exports = __webpack_public_path__ + "static/media/1.1fe37a25.JPG";